import createIcon from '../../createIcon';

/**
 * @component @name GifBox
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk05LjUgMTNWMTJIMTAuNVYxM0MxMC41IDEzLjU1IDEwLjA1IDE0IDkuNSAxNEg4LjVDNy45NSAxNCA3LjUgMTMuNTUgNy41IDEzVjExQzcuNSAxMC40NSA3Ljk1IDEwIDguNSAxMEg5LjVDMTAuMDUgMTAgMTAuNSAxMC40NSAxMC41IDExSDguNVYxM0g5LjVaTTEyLjUgMTRIMTEuNVYxMEgxMi41VjE0Wk0xNi41IDExSDE0LjVWMTEuNUgxNlYxMi41SDE0LjVWMTRIMTMuNVYxMEgxNi41VjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GifBox = createIcon('GifBox', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9.5 13V12H10.5V13C10.5 13.55 10.05 14 9.5 14H8.5C7.95 14 7.5 13.55 7.5 13V11C7.5 10.45 7.95 10 8.5 10H9.5C10.05 10 10.5 10.45 10.5 11H8.5V13H9.5ZM12.5 14H11.5V10H12.5V14ZM16.5 11H14.5V11.5H16V12.5H14.5V14H13.5V10H16.5V11Z',
      key: '1o1it4',
    },
  ],
]);

export default GifBox;
